import { useQuery } from '@tanstack/react-query'

import { getWorkshopSchema } from '@/graphql/queries'
import { AmplifyGraphQLclient } from '@/utils/amplify'

type AuthCodeLoginConfig = { name: 'AuthCodeLoginConfig'; version: '1.0.0' }
type BasicUserGroupingConfig = {
  name: 'BasicUserGroupingConfig'
  version: '1.0.0'
}
type DataIntakeConfig = {
  name: 'DataIntakeConfig'
  version: '2.0.0' | '2.1.0'
}
type DataLookup = { name: 'DataLookup'; version: '1.0.0' }
type EngagementGoalConfig = { name: 'EngagementGoalConfig'; version: '1.2.0' }
type FaqConfig = { name: 'FaqConfig'; version: '1.0.0' | '1.0' }
type HomeBaseMenuConfig = { name: 'HomeBaseMenuConfig'; version: '1.0.0' }
type InLineSignUpConfig = { name: 'InLineSignUpConfig'; version: '1.0.0' }

type IntroConfig = { name: 'IntroConfig'; version: '1.0.0' }
type DataDumpConfig = { name: 'DataDumpConfig'; version: '1.0.0' }
type SimpleApiCallConfig = { name: 'SimpleApiCallConfig'; version: '1.0.0' }
type NotificationTemplatesConfig = {
  name: 'NotificationTemplatesConfig'
  version: '1.0.0'
}
type OrgConfig = { name: 'OrgConfig'; version: '1.0.0' }
type RecipeConfig = { name: 'RecipeConfig'; version: '1.0.0' }
type RedoxWriteBackConfig = { name: 'RedoxWriteBackConfig'; version: '1.0.0' }
type ReleaseBundleConfig = { name: 'ReleaseBundleConfig'; version: '1.0.0' }
type SemanticSearchConfig = {
  name: 'SemanticSearchConfig'
  version: '1.0.0' | '1.0.1'
}
type SentimentCheckConfig = { name: 'SentimentCheckConfig'; version: '1.1.0' }
type TaskTrackerMenuConfig = {
  name: 'TaskTrackerMenuConfig'
  version: '1.0.0'
}
type GenericConfig = { name: string; version: string }

type NameVersionCombo =
  | AuthCodeLoginConfig
  | BasicUserGroupingConfig
  | DataDumpConfig
  | DataIntakeConfig
  | DataLookup
  | EngagementGoalConfig
  | FaqConfig
  | HomeBaseMenuConfig
  | InLineSignUpConfig
  | IntroConfig
  | NotificationTemplatesConfig
  | OrgConfig
  | RecipeConfig
  | RedoxWriteBackConfig
  | ReleaseBundleConfig
  | SemanticSearchConfig
  | SentimentCheckConfig
  | SimpleApiCallConfig
  | GenericConfig
  | TaskTrackerMenuConfig

export const useSchema = ({ name, version }: NameVersionCombo) => {
  return useQuery({
    queryFn: async () => {
      const data = await AmplifyGraphQLclient.graphql({
        query: getWorkshopSchema,
        variables: {
          env: import.meta.env.VITE_APP_LOWER_ENV,
          name,
          version,
        },
      })
      console.log('data', data)

      return JSON.parse(data.data.getWorkshopSchema || '{}')?.data
    },
    queryKey: ['schema', name, version],
    staleTime: Number.MAX_SAFE_INTEGER,
  })
}
